import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { Nav } from './v2/shared';
import Login from './pages/ProfessionalLogin';
import Register from './pages/Register';
import ProfessionalDashboard from './pages/ProfessionalDashboard';
import PatientDashboard from './pages/PatientDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ConfirmEmail from './pages/ConfirmEmail';
import ReservationStatus from './pages/ReservationStatus';
import ProtectedRoute from './components/ProtectedRoute';
import PatientRoute from './components/PatientRoute';
import AdminRoute from './components/AdminRoute';
import FaqV2 from './v2/FaqV2';
import HomeV2 from './v2/HomeV2';
import BookingV2 from './v2/BookingV2';

const ToReservar = () => <Navigate to={`/reservar/${useParams().specialtyId}`} replace />;

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <div className="v2 v2-bare"><Nav /></div>
          <main >
            <Routes>
              <Route path="/" element={<HomeV2 />} />
              <Route path="/old" element={<Navigate to="/" replace />} />
              <Route path="/anterior" element={<Navigate to="/" replace />} />
              <Route path="/preguntas-frecuentes" element={<FaqV2 />} />
              <Route path="/reservar/:specialtyId" element={<BookingV2 />} />
              <Route path="/turno/:token" element={<ReservationStatus />} />
              <Route path="/nuevo" element={<Navigate to="/" replace />} />
              <Route path="/nuevo/reservar/:specialtyId" element={<ToReservar />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              {/* Redirect top-level shortcuts to nested dashboard routes */}
              <Route path="/availability" element={<Navigate to="/dashboard/agenda" replace />} />

              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <ProfessionalDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-appointments"
                element={
                  <PatientRoute>
                    <PatientDashboard />
                  </PatientRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              />
              <Route path="/book/:professionalId" element={<Navigate to="/#especialidades" replace />} />
              <Route path="/book-specialty/:specialtyId" element={<ToReservar />} />
              <Route path="/solicitud-clasica/:specialtyId" element={<ToReservar />} />
              <Route path="/confirmation/:appointmentId" element={<Navigate to="/" replace />} />
              <Route path="/confirm-email" element={<ConfirmEmail />} />
            </Routes>
          </main>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 